<template>
  <div class="default-title">
    <el-table
          ref="tableData"
          class="large-margin-bottom"
          size="mini"
          :data="listData"
          max-height="350px"

          border
          stripe
          :header-cell-style="_headerStyle"
          element-loading-text="加载中"
          style="width: 600px;"
        >
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
          <el-table-column align="left" type="index" width="55" label="序号"></el-table-column>
          <el-table-column prop="businessObject" label="业务对象" ></el-table-column>
          <el-table-column prop="businessAttribute" label="属性" ></el-table-column>
      </el-table>
      <div slot="footer" class="text-align-center" style="position: relative;">
        <el-button size="small" @click="cancel">取 消</el-button>
        <el-button size="small" type="primary" class="title" @click="save">确 定</el-button>
      </div>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination,
  },
  props:['listDataThree'],
  data() {
    return {
      buttonSize:'small',
      listData:[],

    }
  },
  created(){
    this.listData = JSON.parse(JSON.stringify(this.listDataThree))
  },
  methods:{
    cancel(){
      this.$emit('done',{type:'cancel'})
    },
    save(){
      var selection = this.$refs.tableData.selection
      if(selection.length <= 0){
        this.$message.warning('至少选择一个业务对象')
        return
      }
      this.$emit('done',{type:'save',data:selection})
    },
  }
}
</script>
<style>
.list-top-margin .el-input-group__append, .el-input-group__prepend{
  color: #fff;
  background-color: #409EFF;
  border-radius: 0 4px 4px 0;
}
.select-count-content{
  position: absolute;
  left: 0;
  top: -45px;
  font-size: 12px;
}
</style>




// WEBPACK FOOTER //
// src/views/basicData/performAllocation/DimensionCombination.vue